import { Globe } from 'lucide-react'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function GlobalAccountsHeader() {
  return (
    <Card className="relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-cyan-400/10 to-transparent dark:from-cyan-400/5 rounded-full -translate-y-8 translate-x-8" />
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-2xl font-bold tracking-tight flex items-center gap-2">
              <Globe className="h-6 w-6 text-cyan-600 dark:text-cyan-400" />
              Global Accounts
            </CardTitle>
            <p className="text-muted-foreground">Discover top accounts across different categories with analytics insights</p>
          </div>
          <Badge variant="secondary" className="text-xs">
            Explore
          </Badge>
        </div>
      </CardHeader>
    </Card>
  )
} 